import React, {useState} from 'react';
import ModelFileService from "../../../../../API/model-estimate/file/ModelFileService";
import UploadFilesForm from "../../../../form/UploadFilesForm";

export const UploadModelEstimateFileForm = ({label, modelId, change, setChange, handleModalAlert}) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleUpload = async (event) => {
        event.preventDefault();
        ModelFileService.uploadModelEstimateFile(modelId, selectedFile[0])
            .then(function () {
                setChange(!change)
                handleModalAlert("Смета загружена", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(function () {
                event.target.reset();
                setSelectedFile(null)
            })
    }

    return (
        <div>
            <UploadFilesForm
                uploadData={{
                    id: 1,
                    helpText: label,
                }}
                selectedFiles={selectedFile}
                setSelectedFiles={setSelectedFile}
                multiple={false}
                label={label}
                handleUpload={handleUpload}
            />

        </div>
    );
};